var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',_vm._b({attrs:{"href":_vm.url,"title":_vm.title}},'a',_vm.$attrs,false),[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }